import React from 'react';
import { Slider, Radio, Tooltip, InputNumber, Menu, Dropdown, Icon, Button, Input } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

export default class FontWeightEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {
        super.componentWillMount();

        const v = this.props.source.value;
        if (!v)
            this.props.source.value = { mode: "normal", actualValue: "normal" };
    }

    onPxChange(e) {
        console.log(e);
        this.props.source.value = {
            mode: "custom",
            value: e,
            actualValue: e,
        };
        this.setState({});
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }

    onDropDownClick(e) {
        console.log(e);
    }

    onModeChange(e) {
        if (e === "normal") {
            this.props.source.value = {
                mode: "normal", actualValue: "normal"
            };
        }
        else if (e === "bold") {
            this.props.source.value = {
                mode: "bold", actualValue: "bold"
            };
        }
        else if (e === "bolder") {
            this.props.source.value = {
                mode: "bolder", actualValue: "bolder"
            };
        }
        else if (e === "lighter") {
            this.props.source.value = {
                mode: "lighter", actualValue: "lighter"
            };
        }
        else {
            this.props.source.value = {
                mode: "custom",
                value: this.props.source.minValueAbsolute === undefined ? 0 : this.props.source.minValueAbsolute,
                actualValue: this.props.source.minValueAbsolute === undefined ? 0 : this.props.source.minValueAbsolute
            };
        }
    }

    getModeText(e) {
        if (e === "normal") {
            return "常规";
        }
        else if (e === "bold") {
            return "粗体";
        }
        else if (e === "bolder") {
            return "黑体";
        }
        else if (e === "lighter") {
            return "细体";
        }
        else {
            return "自定义";
        }
    }

    render() {

        let value = this.props.source.value;
        if (!value)
            return;

        const mode = value.mode;
        value = value.value;

        const menu = (
            <Menu>
                <Menu.Item key="normal" onClick={e => this.onModeChange("normal")}>常规</Menu.Item>
                <Menu.Item key="bold" onClick={e => this.onModeChange("bold")}>粗体</Menu.Item>
                <Menu.Item key="bolder" onClick={e => this.onModeChange("bolder")}>黑体</Menu.Item>
                <Menu.Item key="lighter" onClick={e => this.onModeChange("lighter")}>细体</Menu.Item>
                <Menu.Divider></Menu.Divider>
                <Menu.Item key="custom" onClick={e => this.onModeChange("custom")}>自定义</Menu.Item>
            </Menu>
        );

        return (
            <div className="property-editor--length">
                <div className="layout-h center hstretch">
                    {
                        mode === "normal" || mode === "bold" || mode === "bolder" || mode === "lighter" ? <Input
                            className="fill"
                            disabled /> : null
                    }
                    {
                        mode === "custom" ? <InputNumber
                            className="fill"
                            value={value}
                            min={this.props.source.minValueAbsolute === undefined ? 0 : this.props.source.minValueAbsolute}
                            max={this.props.source.maxValueAbsolute === undefined ? Number.MAX_SAFE_INTEGER : this.props.source.maxValueAbsolute}
                            onChange={e => this.onPxChange(e)} /> : null
                    }
                    <Dropdown overlay={menu} trigger={['click']}>
                        <Button
                            className='sp-left btn-bd-focus-none btn-pd-sm btn-layer-node btn-bk-hover btn-bd-none'
                            style={{ padding: '5px 5px' }}>
                            {this.getModeText(mode)} <DownOutlined type="down" style={{ marginLeft: 3, fontSize: 10 }} />
                        </Button>
                    </Dropdown>
                </div>
            </div>
        );
    }
}

PropertyGridUtils.register("fontweight", (source, propertyGrid) => <FontWeightEditor source={source} propertyGrid={propertyGrid} />);